class MessageParser {
  constructor(actionProvider, state) {
    this.actionProvider = actionProvider;
    this.state = state;
  }

  parse(message) {
    // On récupère le rôle de l'utilisateur stocké dans l'état du chatbot
    const userRole = this.state.userRole; 
    // On appelle la fonction principale de l'ActionProvider
    this.actionProvider.handleUserMessage(message, userRole);
  }
}

export default MessageParser;